(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function(){
  const wrap = document.getElementById('back-to-top');
  if(!wrap) return;
  const revealAt = 400; // px nach unten, ab wann sichtbar

  function toggle(){
    if(window.scrollY > revealAt){
      wrap.classList.add('is-visible');
    } else {
      wrap.classList.remove('is-visible');
    }
  }
  window.addEventListener('scroll', toggle, {passive:true});
  toggle();

  wrap.addEventListener('click', function(e){
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});
  } catch(e) { console.error(e); }
})();

})();
